import { toEchartData } from '../../../Simple/echarts/dataProcessor';
import { round } from '../../../../../util/numbers/rounder';
import { capitalizeText } from 'src/util/formatters/stringNormalizer';

export default function toEchartOption(resultadosGerais, theme, chartFontSize = 14, disabledLegends, highlitIndex) {
  const echartData = toEchartData(resultadosGerais);
  const { data, legends } = echartData;

  /**
   * Refere-se a um sub-pergunta da pergunta do tipo grade
   */
  const lines = [...new Set(data.map((value) => value.label).reverse())];

  /**
   * Tratando os dados para ficar de forma reverse e ordenado de acordo com:
   * 1. linhas do gráfico
   * 2. legenda do gráfico
   */
  const seriesData = data.reverse()
    .sort((a, b) => {
      if (lines.indexOf(a.label) < lines.indexOf(b.label)) return -1;
      if (lines.indexOf(a.label) > lines.indexOf(b.label)) return 1;
      return 0;
    })
    .sort((a, b) => {
      if (legends.indexOf(a.name) < legends.indexOf(b.name)) return -1;
      if (legends.indexOf(a.name) > legends.indexOf(b.name)) return 1;
      return 0;
    });

  const series = [];
  const selectedLegends = {};

  legends.forEach((legend) => {
    selectedLegends[legend] = !disabledLegends.includes(legend);
    /**
     * Recuperando valores apenas para a legenda do index desejado
     */
    const valuesFromLine = seriesData
      .filter((value) => value.name == legend)
      .map((value, index) => ({
        value: value.value,
        name: value.name,
        numeric: value.numeric,
        itemStyle: {
          ...(index === highlitIndex ? {
            borderType: theme.highlitedItemBorderType,
            borderColor: theme.highlitedItemBorderColor,
            borderWidth: theme.highlitedItemBorderWidth,
          } : {})
        },
      }));

    /**
     * As séries são criadas de acordo com a legenda
     */
    series.push({
      name: legend,
      type: 'bar',
      coordinateSystem: 'polar',
      stack: 'total',
      label: {
        show: true,
        textStyle: {
          fontSize: chartFontSize,
          color: theme.label.text,
        },
        formatter: (params) => (`${round(params.value, 1)}%`),
      },
      emphasis: {
        focus: 'series',
      },
      data: valuesFromLine,
    });
  });

  const tooltipFormatter = (stackItens) => {
    const first = stackItens[0];
    const output = stackItens
      .map((item) => `${item.marker} ${item.seriesName}: ${item.data.numeric} (${item.data.value}%)`)
      .reduce((reduced, next) => reduced.concat('<br>').concat(next));
    const title = lines[first.dataIndex];
    return `${title}<br>${output}`;
  };

  return {
    angleAxis: {
      type: 'category',
      data: lines,
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
          fontSize: chartFontSize,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
    },
    radiusAxis: {
      axisLine: {
        lineStyle: {
          color: theme.radar.radiusAxis.line,
        },
      },
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
        },
      },
      splitLine: {
        lineStyle: {
          color: theme.radar.radiusAxis.splitLine,
        },
      },
    },
    polar: {},
    color: theme.colors,
    animationDuration: 0,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter,
    },
    legend: {
      selected: selectedLegends,
      icon: 'circle',
      left: 'left',
      top: '-1%',
      type: 'scroll',
      textStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    grid: {
      left: '3%',
      right: '15%',
      bottom: '3%',
      containLabel: true,
    },
    series,
  };
}
